/* FASHIONSHUBS — slide-out cart drawer with upsells & shipping protection */
(function () {
  var INS_ID = 50623749587192;            // Shipping Protection: orders under $20,000 ($9.99, opt-in)
  var INS_HI_ID = 67519338709240;         // Shipping Protection: orders $20,000 and over ($49)
  var INS_THRESHOLD = 2000000;            // cents
  var isIns = function (i) { return i.variant_id === INS_ID || i.variant_id === INS_HI_ID; };
  // Threshold and fees are set in USD; convert them to the shopper's currency.
  var RATE = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var insPrice = {}; insPrice[INS_ID] = Math.round(999 * RATE); insPrice[INS_HI_ID] = Math.round(4900 * RATE);
  fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/shipping-protection.js').then(function (r) { return r.json(); }).then(function (p) {
    (p.variants || []).forEach(function (v) { insPrice[v.id] = v.price; });
  }).catch(function () {});
  var insFor = function (cart) {
    var sub = cart.items.reduce(function (s, i) { return isIns(i) ? s : s + i.final_line_price; }, 0);
    var id = sub >= INS_THRESHOLD * RATE ? INS_HI_ID : INS_ID;
    return { id: id, price: insPrice[id] };
  };
  var INS_HANDLE = 'shipping-protection';
  var OFF_KEY = 'fh_ins_off';             // customer unchecked protection
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  var money = function (c) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var img = function (u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var offGet = function () { try { return sessionStorage.getItem(OFF_KEY) === '1'; } catch (e) { return false; } };
  var offSet = function (v) { try { v ? sessionStorage.setItem(OFF_KEY, '1') : sessionStorage.removeItem(OFF_KEY); } catch (e) {} };

  var api = function (url, body) {
    return fetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };

  /* ---------- Drawer markup ---------- */
  var el = document.createElement('div');
  el.className = 'fhc';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML =
    '<div class="fhc__overlay" data-fhc-close></div>' +
    '<aside class="fhc__panel" role="dialog" aria-modal="true" aria-label="Shopping bag">' +
      '<header class="fhc__head"><h2>Your Bag <span data-fhc-count></span></h2><button type="button" class="fhc__x" data-fhc-close aria-label="Close">&times;</button></header>' +
      '<div class="fhc__notice" data-fhc-notice hidden></div>' +
      '<div class="fhc__body" data-fhc-body></div>' +
      '<footer class="fhc__foot" data-fhc-foot></footer>' +
    '</aside>';
  document.body.appendChild(el);
  var body = el.querySelector('[data-fhc-body]'), foot = el.querySelector('[data-fhc-foot]');

  var open = function () { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('fhc-lock'); };
  var close = function () { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('fhc-lock'); };
  el.addEventListener('click', function (e) { if (e.target.closest('[data-fhc-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });

  var updateBubbles = function (n) {
    document.querySelectorAll('.cart-bubble__text, .cart-count, [data-cart-count], .cart-bubble__text-count').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', n === 0); });
  };

  /* ---------- Estimated delivery ---------- */
  var eta = function () {
    var now = new Date(), a = new Date(now), b = new Date(now), k = 3;
    while (k > 0) { a.setDate(a.getDate() + 1); if (a.getDay() % 6) k--; }
    b.setDate(b.getDate() + 7);
    var f = { weekday: 'short', month: 'short', day: 'numeric' };
    return a.toLocaleDateString('en-US', f) + ' – ' + b.toLocaleDateString('en-US', f);
  };

  /* ---------- Render ---------- */
  var render = function (cart) {
    var items = cart.items.filter(function (i) { return !isIns(i); });
    var ins = cart.items.filter(function (i) { return isIns(i); })[0];
    var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    el.querySelector('[data-fhc-count]').textContent = n ? '(' + n + ')' : '';
    updateBubbles(n);

    if (!items.length) {
      body.innerHTML = '<div class="fhc__empty"><p>Your bag is empty.</p><a class="fhc__btn fhc__btn--outline" href="/collections/bags">Shop Handbags</a><a class="fhc__link" href="/collections/jewelry">Discover Fine Jewelry</a></div>';
      foot.innerHTML = '';
      if (ins) api('cart/change.js', { id: ins.key, quantity: 0 });
      return;
    }

    body.innerHTML =
      '<ul class="fhc__items">' + items.map(function (i) {
        return '<li class="fhc__item">' +
          '<a class="fhc__img" href="' + i.url + '">' + (i.image ? '<img src="' + img(i.image, 240) + '" alt="' + esc(i.vendor + ' ' + i.product_title) + '">' : '') + '</a>' +
          '<div class="fhc__info"><div class="fhc__vendor">' + esc(i.vendor) + '</div>' +
          '<a class="fhc__title" href="' + i.url + '">' + esc(i.product_title) + '</a>' +
          '<div class="fhc__meta">One of a kind' + (i.quantity > 1 ? ' · Qty ' + i.quantity : '') + '</div>' +
          '<div class="fhc__row"><span class="fhc__price">' + money(i.final_line_price) + '</span>' +
          '<span class="fhc__acts"><button type="button" class="fhc__remove" data-fhc-save="' + i.key + '" data-handle="' + esc(i.handle) + '">Move to Wishlist</button><button type="button" class="fhc__remove" data-fhc-remove="' + i.key + '">Remove</button></span></div></div></li>';
      }).join('') + '</ul>' +
      '<label class="fhc__ins">' +
        '<input type="checkbox" data-fhc-ins' + (ins ? ' checked' : '') + '>' +
        '<span class="fhc__ins-box" aria-hidden="true"></span>' +
        '<span class="fhc__ins-text"><strong>Add Extra Shipping Protection — ' + money(insFor(cart).price) + '</strong>' +
        '<small>Every order already ships insured. This optional extra coverage adds priority claim handling and a faster replacement or refund if your parcel is lost, stolen or damaged.</small></span>' +
      '</label>' +
      '<div class="fhc__eta"><span>Estimated delivery</span><strong>' + eta() + '</strong></div>' +
      '<label class="fhc__opt"><input type="checkbox" data-fhc-wrap' + (cart.attributes && cart.attributes['Gift wrap'] === 'Yes' ? ' checked' : '') + '><span class="fhc__ins-box" aria-hidden="true"></span><span><strong>Complimentary gift wrapping</strong><small>Signature black box with ribbon.</small></span></label>' +
      '<details class="fhc__note"><summary>Add a gift note</summary><textarea data-fhc-note rows="3" maxlength="300" placeholder="Your message (printed on a card)">' + esc(cart.note || '') + '</textarea></details>' +
      '<section class="fhc__summary">' +
        '<form class="fhc__code" data-fhc-code><input type="text" name="code" placeholder="Discount code" aria-label="Discount code" autocomplete="off"><button type="submit">Apply</button></form>' +
        ((cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return '<div class="fhc__applied">' + esc(d.code) + ' <button type="button" data-fhc-uncode aria-label="Remove code">&times;</button></div>'; }).join('')) +
        ((cart.discount_codes || []).some(function (d) { return !d.applicable; }) ? '<p class="fhc__err">This code is not valid for your bag.</p>' : '') +
        '<div class="fhc__line"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>' +
        (cart.total_discount ? '<div class="fhc__line fhc__line--disc"><span>Discount</span><span>−' + money(cart.total_discount) + '</span></div>' : '') +
        '<p class="fhc__small">Taxes and shipping calculated at checkout.</p>' +
        '<ul class="fhc__trust"><li>Authenticity Guaranteed</li><li>Free Returns within 14 Days</li><li>Secure Payment</li></ul>' +
        '<p class="fhc__help">Questions? Our concierge is here: <a href="mailto:us@fashionshubs.store">us@fashionshubs.store</a> · <a href="/pages/contact">Contact</a></p>' +
        '<a class="fhc__link" href="/cart">View Bag</a>' +
      '</section>' +
      '<section class="fhc__upsell" data-fhc-upsell hidden><h3>Complete the Look</h3><div class="fhc__upsell-list"></div></section>';

    foot.innerHTML =
      '<div class="fhc__bar"><div class="fhc__bar-total"><span>Total</span><strong>' + money(cart.total_price) + '</strong>' +
      (cart.total_discount ? '<small>You save ' + money(cart.total_discount) + '</small>' : '<small>Taxes &amp; shipping at checkout</small>') + '</div>' +
      '<a class="fhc__btn fhc__btn--bar" href="/checkout">Secure Checkout</a></div>';

    loadUpsells(items);
  };

  /* ---------- Upsells ---------- */
  var loadUpsells = function (items) {
    var box = el.querySelector('[data-fhc-upsell]'); if (!box) return;
    var inCart = items.map(function (i) { return i.product_id; });
    var pid = items[0].product_id;
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return inCart.indexOf(p.id) < 0 && p.handle !== INS_HANDLE && p.available; }).slice(0, 4);
        if (!list.length) return;
        box.querySelector('.fhc__upsell-list').innerHTML = list.map(function (p) {
          return '<div class="fhc__up"><a href="/products/' + p.handle + '" class="fhc__up-img"><img src="' + img(p.featured_image, 200) + '" alt="' + esc(p.vendor + ' ' + p.title) + '" loading="lazy"></a>' +
            '<div class="fhc__up-info"><div class="fhc__vendor">' + esc(p.vendor) + '</div><a class="fhc__up-title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
            '<div class="fhc__up-row"><span>' + money(p.price) + '</span><button type="button" class="fhc__add" data-fhc-add="' + p.variants[0].id + '">Add</button></div></div></div>';
        }).join('');
        box.hidden = false;
      }).catch(function () {});
  };

  /* ---------- Cart logic ---------- */
  var busy = false;
  var refresh = function () {
    return api('cart.js').then(function (cart) {
      var items = cart.items.filter(function (i) { return !isIns(i); });
      var ins = cart.items.filter(function (i) { return isIns(i); })[0];
      var want = insFor(cart);
      if (ins && ins.variant_id !== want.id) {
        return api('cart/change.js', { id: ins.key, quantity: 0 }).then(function () {
          return api('cart/add.js', { items: [{ id: want.id, quantity: 1 }] });
        }).then(function () { return api('cart.js'); });
      }
      if (ins && ins.quantity > 1) return api('cart/change.js', { id: ins.key, quantity: 1 });
      return cart;
    }).then(render);
  };
  var notice = function (msg) {
    var n = el.querySelector('[data-fhc-notice]'); n.textContent = msg; n.hidden = !msg;
  };
  var addToCart = function (variantId, btn) {
    if (busy) return; busy = true;
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    notice('');
    return api('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function () { return refresh(); })
      .then(function () { notice('Added to your bag'); open(); })
      .catch(function (err) { notice((err && (err.description || err.message)) || 'This piece is no longer available.'); refresh().then(open); })
      .then(function () { busy = false; if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; } });
  };

  // Product page "Add to Bag"
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var id = f.querySelector('[name="id"]'); if (!id) return;
    e.preventDefault();
    addToCart(id.value, f.querySelector('[type="submit"]'));
  }, true);

  // Drawer actions
  el.addEventListener('click', function (e) {
    var r = e.target.closest('[data-fhc-remove]');
    if (r) { r.textContent = '…'; api('cart/change.js', { id: r.getAttribute('data-fhc-remove'), quantity: 0 }).then(refresh); return; }
    var sv = e.target.closest('[data-fhc-save]');
    if (sv) {
      try { var wl = JSON.parse(localStorage.getItem('fh_wishlist') || '[]'), h = sv.getAttribute('data-handle'); if (wl.indexOf(h) < 0) wl.unshift(h); localStorage.setItem('fh_wishlist', JSON.stringify(wl.slice(0, 60))); } catch (x) {}
      sv.textContent = '…'; api('cart/change.js', { id: sv.getAttribute('data-fhc-save'), quantity: 0 }).then(refresh).then(function () { notice('Saved to your wishlist'); }); return;
    }
    if (e.target.closest('[data-fhc-uncode]')) { api('cart/update.js', { discount: '' }).then(refresh); return; }
    var a = e.target.closest('[data-fhc-add]');
    if (a) { addToCart(a.getAttribute('data-fhc-add'), a); }
  });
  el.addEventListener('change', function (e) {
    var c = e.target.closest('[data-fhc-ins]');
    if (c) {
      c.disabled = true;
      if (c.checked) { offSet(false); api('cart.js').then(function (cart) { return api('cart/add.js', { items: [{ id: insFor(cart).id, quantity: 1 }] }); }).then(refresh); }
      else { offSet(true); api('cart.js').then(function (cart) { var ins = cart.items.filter(function (i) { return isIns(i); })[0]; return ins ? api('cart/change.js', { id: ins.key, quantity: 0 }) : cart; }).then(refresh); }
      return;
    }
    var wr = e.target.closest('[data-fhc-wrap]');
    if (wr) { api('cart/update.js', { attributes: { 'Gift wrap': wr.checked ? 'Yes' : '' } }); return; }
    var nt = e.target.closest('[data-fhc-note]');
    if (nt) api('cart/update.js', { note: nt.value });
  });

  el.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-fhc-code]'); if (!f) return;
    e.preventDefault();
    var code = f.code.value.trim(); if (!code) return;
    f.querySelector('button').textContent = '…';
    api('cart/update.js', { discount: code }).then(refresh).catch(function () { notice('Unable to apply this code.'); refresh(); });
  });

  // Open drawer from header cart icon
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href$="/cart"], a[href="/cart"], cart-icon, .header-actions__cart-icon, [data-testid="cart-icon"], button[aria-controls="cart-drawer"], .cart-drawer__trigger');
    if (!t || el.contains(t) || t.closest('.fhc')) return;
    if (window.location.pathname === '/cart') return;
    e.preventDefault(); e.stopPropagation();
    refresh().then(open);
  }, true);

  // Keep protection in sync on the /cart page too
  if (window.location.pathname === '/cart') refresh();

  // The theme ships its own cart drawer (#cart-drawer). Keep it closed so only this drawer opens.
  var themeDrawer = document.getElementById('cart-drawer');
  if (themeDrawer) {
    var shutTheme = function () {
      var d = themeDrawer.querySelector('dialog');
      if (d && d.open) { try { d.close(); } catch (err) {} }
      if (themeDrawer.hasAttribute('open')) themeDrawer.removeAttribute('open');
      document.querySelectorAll('.page-wrapper--drawer-open').forEach(function (p) { p.classList.remove('page-wrapper--drawer-open'); });
      document.documentElement.removeAttribute('scroll-lock');
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    };
    new MutationObserver(function () {
      var d = themeDrawer.querySelector('dialog');
      if (themeDrawer.hasAttribute('open') || (d && d.open)) {
        shutTheme();
        if (!el.classList.contains('is-open')) refresh().then(open);
      }
    }).observe(themeDrawer, { attributes: true, subtree: true, attributeFilter: ['open'] });
    shutTheme();
    setTimeout(shutTheme, 300);
    window.addEventListener('load', shutTheme);
  }

  window.FHCart = { open: function () { refresh().then(open); }, close: close, refresh: refresh };
})();
